import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import App from "./App";
import About from "./components/About";



const RouteSwitch = () => {
    const queryClient = new QueryClient()
  return (
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="/about" element= {<About/>} />
        </Routes>
        </BrowserRouter>
    </QueryClientProvider>
  );
};

export default RouteSwitch;